export const dateFilterOptions = [
  { value: "MONTHLY", label: "Monthly" },
  { value: "OTHER", label: "Other" },
];

export const businessServiceOrderStatus = [
  {
    value: "PENDING",
    label: "Pending",
    type: "alert",
  },
  {
    value: "CONSULTATION",
    label: "businessServiceOrderDetailStep.consultation",
    type: "primary",
  },
  {
    value: "DOCUMENT_COLLECTION",
    label: "businessServiceOrderDetailStep.documentCollection",
    type: "primary",
  },
  {
    value: "NAME_VALIDATION",
    label: "businessServiceOrderDetailStep.nameValidation",
    type: "primary",
  },
  {
    value: "KBLI_SELECTION",
    label: "businessServiceOrderDetailStep.kbliSelection",
    type: "primary",
  },
  {
    value: "AKTA_SK_REGISTRATION",
    label: "businessServiceOrderDetailStep.aktaSkRegistration",
    type: "primary",
  },
  {
    value: "TAX_ID_REGISTRATION",
    label: "businessServiceOrderDetailStep.taxIdRegistration",
    type: "primary",
  },
  {
    value: "NIB_OSS_REGISTRATION",
    label: "businessServiceOrderDetailStep.nibOssRegistration",
    type: "primary",
  },
  {
    value: "IN_PROGRESS",
    label: "businessServiceOrderDetailStep.inProgress",
    type: "primary",
  },
  {
    value: "FINISHED",
    label: "businessServiceOrderDetailStep.finished",
    type: "success",
  },
  {
    value: "CANCELLED",
    label: "Cancelled",
    type: "danger",
  },
];
